<template>
	<modal id="confirmationMessage">
		<template #modal-header>
			<div class="grid-x grid-padding-x">
				<!-- Title -->
				<div class="large-12 medium-12 cell">
					<h1>
						<span style="font-weight: normal"> {{ titleFirstWord }} </span> {{ titleFormatted }}
					</h1>
				</div>
			</div>
		</template>
		<template #modal-body>
			<div class="grid-container">
				<div class="grid-x grid-padding-x message">
					<!-- Confirmation Message -->
					<div class="large-3 medium-3 small-3 cell">
						<i class="bi bi-check-circle-fill"> </i>
					</div>
					<div class="large-9 medium-9 small-9 cell">
						<p class="h4" style="padding-top: 2vh">
							{{ $t('messages.modals.confirmation.message') }}
						</p>
					</div>
				</div>
			</div>
		</template>
		<template #modal-footer>
			<button class="button call-to-action large expanded" @click="uiOptions().toggleModal('confirmationMessage')">
				<i class="bi bi-chevron-right"> </i>{{ $t('messages.modals.confirmation.close') }}
			</button>
		</template>
	</modal>
</template>
<script lang="ts">
/* eslint-disable vue/no-setup-props-destructure */
import { defineComponent, PropType, ref } from 'vue'
import { uiOptions } from '@/config'

export default defineComponent({
	name: 'ConfirmationMessage',
	props: {
		title: {
			type: String as PropType<string>,
			required: true,
		},
		message: {
			type: String as PropType<string>,
			default:
				'Ihre Anfrage ist bei uns eingegangen. Sie werden in Kürze ein Angebot für die angefragte Leistung per E-mail erhalten.',
		},
	},
	setup({ title }) {
		let titleArray = title.split(' ')
		const titleFirstWord = ref(titleArray[0])
		const [, ...rest] = titleArray
		const titleFormatted = ref(rest.join(' '))
		return { titleFirstWord, titleFormatted, uiOptions }
	},
})
</script>
